import resolvePublicAsset from '../utils/resolvePublicAsset';

const circuitoEdicoes = [
  {
    slug: '1-edicao',
    ano: '2024',
    titulo: '1ª EDIÇÃO',
    resumo: 'A primeira circulação consolidou a proposta do projeto no interior paulista com ações culturais em quatro cidades.',
    imagem: resolvePublicAsset('/images/acesso_acontece.jpeg'),
    alt: 'Registro da primeira edição do Circuito Paulista de Hip Hop',
    destaques: [
      'Primeira circulação regional do projeto com foco em formação e ocupação cultural.',
      'Articulação com coletivos locais para compor programação e mobilização territorial.',
      'Atividades abertas ao público com forte presença da juventude e da cultura urbana.'
    ],
    descricao: [
      'A 1ª Edição do Circuito Paulista de Hip Hop marcou o início da circulação do projeto por cidades do interior paulista, estruturando um modelo de atuação baseado em articulação local, acesso gratuito e protagonismo dos artistas de cada território.',
      'Com passagem por Barretos, Bauru, Porto Feliz e Ourinhos, a edição reuniu apresentações, oficinas e encontros voltados à difusão do Hip Hop como linguagem artística e ferramenta de mobilização cultural.',
      'Essa etapa inaugurou uma rede de colaboração entre coletivos, artistas e agentes culturais que se tornaria base para o crescimento das edições seguintes.'
    ],
    cidades: [
      {
        slug: 'barretos',
        nome: 'Barretos',
        imagem: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/ding.png'),
        alt: 'Circuito Paulista de Hip Hop em Barretos',
        resumo: 'Três dias de batalhas, oficinas formativas e shows com nomes como Eduardo Taddeo, Cronica Mendes e Sharylaine.',
        descricao: [
          'A etapa de Barretos aconteceu entre os dias 27 e 29 de setembro de 2024 e trouxe uma programação diversa que ocupou a cidade ao longo de três dias. A abertura ficou por conta da Batalha de MCs Briga de Viralatas e do Baile Black, conectando o público à cultura de rua logo na primeira noite.',
          'No segundo dia, o foco foi a formação: oficinas de fotografia por celular, skate, graffiti, arte em garrafa, dança urbana e deejay abriram espaço para troca de conhecimento e experimentação artística, seguidas de uma batalha de rima.',
          'O encerramento reuniu apresentações de Sons of Guerrilha, Radiação X, Embaixada Records, Tuca Lélis, Janaina Jascone, Sharylaine, Cronica Mendes, Crazy Punk Crew, Guetto Beatz e Eduardo Taddeo, consolidando a etapa como um ponto de encontro entre a cena local e artistas de projeção nacional.'
        ],
        galeria: [
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_01.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_02.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_03.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_04.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_05.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_06.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_07.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_08.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_09.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_10.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_11.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/barretos/galeria_12.png'),
            alt: 'Circuito Paulista de Hip Hop em Barretos'
          }
        ],
        programacao: [
          { dia: '27/09/2024', horario: '19h', descricao: 'Batalha de MCs - Briga de Viralatas' },
          { dia: '27/09/2024', horario: '21h', descricao: 'Baile Black' },
          { dia: '28/09/2024', horario: '14h', descricao: 'Oficina de Fotografia por celular' },
          { dia: '28/09/2024', horario: '14h30', descricao: 'Oficina de Skate' },
          { dia: '28/09/2024', horario: '15h', descricao: 'Oficina de Graffiti' },
          { dia: '28/09/2024', horario: '15h30', descricao: 'Oficina de Arte em Garrafa' },
          { dia: '28/09/2024', horario: '16h', descricao: 'Oficina de Dança Urbana' },
          { dia: '28/09/2024', horario: '16h30', descricao: 'Oficina de Deejay' },
          { dia: '28/09/2024', horario: '17h', descricao: 'Abayomi' },
          { dia: '28/09/2024', horario: '17h30', descricao: 'Batalha de Rima' },
          { dia: '29/09/2024', horario: '15h', descricao: 'Sons of Guerrilha' },
          { dia: '29/09/2024', horario: '15h30', descricao: 'Radiação X / Caborja' },
          { dia: '29/09/2024', horario: '16h15', descricao: 'Embaixada Records / GMC' },
          { dia: '29/09/2024', horario: '16h30', descricao: 'Tuca Lélis / Janaina Jascone / Sharylaine' },
          { dia: '29/09/2024', horario: '17h30', descricao: 'Cronica Mendes / DJ Shinpa' },
          { dia: '29/09/2024', horario: '18h30', descricao: 'Crazy Punk Crew' },
          { dia: '29/09/2024', horario: '18h45', descricao: 'Guetto Beatz' },
          { dia: '29/09/2024', horario: '19h30', descricao: 'Eduardo Taddeo' }
        ]
      },
      {
        slug: 'bauru',
        nome: 'Bauru',
        imagem: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_01.png'),
        alt: 'Circuito Paulista de Hip Hop em Bauru',
        resumo: 'Sete dias de programação com Hip Hop Kids, palestras, batalhas, encontro de graffiti e shows de encerramento com Eduardo Taddeo e Crônica Mendes.',
        descricao: [
          'A Semana Hip Hop Origens, 1ª edição, aconteceu em Bauru entre 7 e 13 de outubro de 2024, com uma programação extensa de sete dias que combinou formação, acessibilidade e grandes apresentações. O projeto Hip Hop Kids levou atividades a espaços como Wise New, Wise Rasi, Legião Mirim, Vera Campagnani e Wise Life, aproximando crianças e jovens da cultura hip hop.',
          'A programação incluiu palestras sobre inclusão e acessibilidade na produção de eventos culturais, o Abrakbça com Renan Inquérito, o Rap Hour, a Batalha dos 13, a Noite dos DJs no Voodo Lounge Pub e uma Batalha de Breaking, abrangendo todos os elementos do hip hop ao longo da semana.',
          'O encerramento contou com o Encontro de Graffiti no Parque Vitória Régia e uma sequência de shows com Ment Blindada, Luana Hansen, Arnaldo Tifu, Pateta Código 43, Sharylaine, Tuca Léllis, Crônica Mendes e Eduardo Taddeo.'
        ],
        galeria: [
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_01.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_02.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_03.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_04.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_05.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_06.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_07.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_08.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_09.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_10.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/bauru/galeria_11.png'),
            alt: 'Circuito Paulista de Hip Hop em Bauru'
          }
        ],
        programacao: [
          { dia: '07/10/2024', horario: '14h', descricao: 'Semana do Hip Hop Kids - Wise New' },
          { dia: '08/10/2024', horario: '09h', descricao: 'Semana do Hip Hop Kids - Wise Rasi' },
          { dia: '08/10/2024', horario: '14h', descricao: 'Semana do Hip Hop Kids - Legião Mirim' },
          { dia: '08/10/2024', horario: '15h', descricao: 'Palestra Inclusão e Acessibilidade: Vivência na Prática' },
          { dia: '09/10/2024', horario: '13h', descricao: 'Semana do Hip Hop Kids - Vera Campagnani' },
          { dia: '09/10/2024', horario: '14h', descricao: 'Semana do Hip Hop Kids - Legião Mirim Piratininga' },
          { dia: '09/10/2024', horario: '14h', descricao: 'Abrakbça com Renan Inquérito' },
          { dia: '09/10/2024', horario: '19h', descricao: 'Troca de Folinha - Loja Salve' },
          { dia: '10/10/2024', horario: '09h', descricao: 'Semana do Hip Hop Kids - Wise Galpão' },
          { dia: '10/10/2024', horario: '19h', descricao: 'Rap Hour' },
          { dia: '10/10/2024', horario: '19h30', descricao: 'Palestra Inclusão e Acessibilidade na Produção de Eventos Culturais por Caroline Ferreira - SESC' },
          { dia: '11/10/2024', horario: '09h', descricao: 'Semana do Hip Hop Kids - Wise Life' },
          { dia: '11/10/2024', horario: '19h', descricao: 'Batalha dos 13' },
          { dia: '11/10/2024', horario: '21h', descricao: 'Noite dos DJs - Voodo Lounge Pub' },
          { dia: '12/10/2024', horario: '14h', descricao: 'Batalha de Breaking' },
          { dia: '13/10/2024', horario: '09h', descricao: 'Encontro de Graffiti - Parque Vitória Régia' },
          { dia: '13/10/2024', horario: '15h', descricao: 'Ment Blindada, Betin MC e Estrofe' },
          { dia: '13/10/2024', horario: '16h', descricao: 'Luana Hansen, Lôly e Mandex' },
          { dia: '13/10/2024', horario: '17h', descricao: 'Arnaldo Tifu e Stefanie' },
          { dia: '13/10/2024', horario: '18h', descricao: 'Pateta Código 43' },
          { dia: '13/10/2024', horario: '19h', descricao: 'Sharylaine, Tuca Léllis e Janaína' },
          { dia: '13/10/2024', horario: '20h', descricao: 'Crônica Mendes' },
          { dia: '13/10/2024', horario: '21h', descricao: 'Eduardo Taddeo' }
        ]
      },
      {
        slug: 'porto-feliz',
        nome: 'Porto Feliz',
        imagem: resolvePublicAsset('/images/capa_porto_feliz.png'),
        alt: 'Circuito Paulista de Hip Hop em Porto Feliz',
        resumo: 'Batalha da Pista, vivências de skate, roda de conversa e shows de encerramento com Afro-X, Crônica Mendes e Eduardo Taddeo.',
        descricao: [
          'A etapa de Porto Feliz aconteceu entre os dias 22 e 24 de novembro de 2024, com uma programação que cruzou cultura urbana e formação. A abertura trouxe a Batalha da Pista, seguida no segundo dia por atividades de skate, uma roda de conversa sobre produção cultural e processo criativo audiovisual com a Internus, e o Encontro de DJs no Bar do Zuuh.',
          'O domingo de encerramento reuniu apresentações de K1rk com Jota_Cê e Lil Lins, Jess MC, Nugê, Afro-X (509-E), Tuca Lelis ao lado de Sharylaine, Janaína Jascone e Lauren, Crônica Mendes e Eduardo Taddeo, reafirmando Porto Feliz como ponto estratégico do circuito no interior paulista.'
        ],
        galeria: [
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_01.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_02.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_03.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_04.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_05.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_06.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_07.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_08.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_09.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_10.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_11.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_12.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/porto_feliz/galeria_13.png'),
            alt: 'Circuito Paulista de Hip Hop em Porto Feliz'
          }
        ],
        programacao: [
          { dia: '22/11/2024', horario: '19h', descricao: 'Batalha da Pista' },
          { dia: '23/11/2024', horario: '14h', descricao: 'Atividades de Skate' },
          { dia: '23/11/2024', horario: '16h', descricao: 'Roda de Conversa sobre Produção Cultural e Processo Criativo das Produções Audiovisuais de Skate da Internus' },
          { dia: '23/11/2024', horario: '20h30', descricao: 'Encontro de DJs no Bar do Zuuh' },
          { dia: '24/11/2024', horario: '14h', descricao: 'K1rk - Feat Jota_Cê & Lil Lins' },
          { dia: '24/11/2024', horario: '15h', descricao: 'Jess MC' },
          { dia: '24/11/2024', horario: '16h', descricao: 'Nugê' },
          { dia: '24/11/2024', horario: '17h', descricao: 'Afro-X (509-E)' },
          { dia: '24/11/2024', horario: '18h', descricao: 'Tuca Lelis, Sharylaine, Janaína Jascone e Lauren' },
          { dia: '24/11/2024', horario: '19h', descricao: 'Crônica Mendes' },
          { dia: '24/11/2024', horario: '20h', descricao: 'Eduardo Taddeo' }
        ]
      },
      {
        slug: 'ourinhos',
        nome: 'Ourinhos',
        imagem: resolvePublicAsset('/images/capa_ourinhos.png'),
        alt: 'Circuito Paulista de Hip Hop em Ourinhos',
        resumo: 'Três dias com batalha, encontros de graffiti e DJs, campeonato de skate e shows de Mano Fler, Realidade Cruel e Crônica Mendes.',
        descricao: [
          'A etapa de Ourinhos encerrou a 1ª Edição do Circuito entre os dias 6 e 8 de dezembro de 2024, reunindo os cinco elementos do hip hop em uma programação intensa. A abertura trouxe a Batalha da Drink, seguida no segundo dia pelo Encontro de Graffiti, o Encontro dos DJs, um cypher de Breaking e Pocket Shows.',
          'O dia de encerramento começou cedo com o Campeonato de Skate e a Perifeirinha, e seguiu com a Final da Batalha de MCs e uma sequência de shows que incluiu Vemcido, Rapper Scooby, Diversidade Lirica, Tons Afro, Maykvelli com Mandex e Loly, DJ Ding, Afro-X, Realidade Cruel, Mano Fler e Crônica Mendes.'
        ],
        galeria: [
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_01.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_02.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_03.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_04.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_05.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_06.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_07.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_08.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_09.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_10.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_11.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_12.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_13.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_14.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_15.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_16.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_17.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_18.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_19.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_20.png'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/1aedicao/ourinhos/galeria_21.jpg'),
            alt: 'Circuito Paulista de Hip Hop em Ourinhos'
          }
        ],
        programacao: [
          { dia: '06/12/2024', horario: '19h', descricao: 'Batalha da Drink' },
          { dia: '07/12/2024', horario: '14h', descricao: 'Encontro de Graffiti' },
          { dia: '07/12/2024', horario: '15h30', descricao: 'Encontro dos DJs' },
          { dia: '07/12/2024', horario: '18h30', descricao: 'cypher de Breaking' },
          { dia: '07/12/2024', horario: '20h', descricao: 'Pocket Shows' },
          { dia: '08/12/2024', horario: '08h', descricao: 'Campeonato de Skate' },
          { dia: '08/12/2024', horario: '11h', descricao: 'Perifeirinha' },
          { dia: '08/12/2024', horario: '14h', descricao: 'Vemcido' },
          { dia: '08/12/2024', horario: '14h30', descricao: 'Rapper Scooby' },
          { dia: '08/12/2024', horario: '15h', descricao: 'Diversidade Lirica' },
          { dia: '08/12/2024', horario: '15h30', descricao: 'Tons Afro' },
          { dia: '08/12/2024', horario: '16h', descricao: 'Maykvelli, Mandex e Loly' },
          { dia: '08/12/2024', horario: '16h30', descricao: 'Final da Batalha de MCs' },
          { dia: '08/12/2024', horario: '17h', descricao: 'DJ Ding' },
          { dia: '08/12/2024', horario: '17h30', descricao: 'Afro-X' },
          { dia: '08/12/2024', horario: '18h30', descricao: 'Realidade Cruel' },
          { dia: '08/12/2024', horario: '19h30', descricao: 'Mano Fler' },
          { dia: '08/12/2024', horario: '20h30', descricao: 'Crônica Mendes' }
        ]
      }
    ]
  },
  {
    slug: '2-edicao',
    ano: '2025/2026',
    titulo: '2ª EDIÇÃO',
    resumo: 'A segunda edição ampliou a rede do projeto, alcançando mais cidades e fortalecendo a troca entre cenas locais.',
    imagem: resolvePublicAsset('/images/foto_acesso.png'),
    alt: 'Registro da segunda edição do Circuito Paulista de Hip Hop',
    destaques: [
      'Expansão territorial com circulação em cinco cidades do interior.',
      'Ampliação das parcerias com coletivos, produtores e artistas independentes.',
      'Fortalecimento da formação de público e da visibilidade para cenas regionais.'
    ],
    descricao: [
      'Na 2ª Edição, o Circuito Paulista de Hip Hop avançou em capilaridade e alcance, fortalecendo sua presença em diferentes regiões do estado e consolidando uma rede mais ampla de colaboração cultural.',
      'As ações em Porto Feliz, Salto, Bauru, Marília e Araraquara aprofundaram o diálogo com as cenas locais, conectando formação, fruição artística e valorização de expressões urbanas contemporâneas.',
      'A edição reforçou o papel do projeto como plataforma de circulação, encontro e reconhecimento do Hip Hop como produção cultural estratégica para os territórios.'
    ],
    cidades: [
      {
        slug: 'porto-feliz',
        nome: 'Porto Feliz',
        imagem: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/capa.png'),
        alt: 'Circuito Paulista de Hip Hop em Porto Feliz na segunda edição',
        resumo: 'Hip Hop na Escola, Batalha da Pista, Best Trick e shows de encerramento com GOG e Renan Inquérito.',
        descricao: [
          'Porto Feliz abriu a 2ª Edição do Circuito entre os dias 12 e 14 de setembro de 2025, com uma programação que começou dentro das escolas. O Hip Hop na Escola levou a cultura urbana para o ambiente educacional pela manhã, enquanto à noite a Batalha da Pista agitou a cidade.',
          'O segundo dia trouxe o Best Trick de skate e o Encontro de DJs. O encerramento contou com uma sequência de shows que reuniu Kirk & Lil Lins, AK-47, Dory de Oliveira, Dona Kelly, Tuca Lélis, X da Questão, Cris CNJ, e fechou com dois nomes de peso do rap nacional: GOG e Renan Inquérito.'
        ],
        galeria: [
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_01.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_02.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_03.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_04.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_05.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_06.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_07.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_08.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_09.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_10.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Porto Feliz'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/porto_feliz/galeria_11.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Porto Feliz'
          }
        ],
        programacao: [
          { dia: '12/09/2025', horario: '07h', descricao: 'Hip Hop na Escola' },
          { dia: '12/09/2025', horario: '19h', descricao: 'Batalha da Pista' },
          { dia: '13/09/2025', horario: '13h', descricao: 'Best Trick' },
          { dia: '13/09/2025', horario: '19h', descricao: 'Encontro de DJs' },
          { dia: '14/09/2025', horario: '14h', descricao: 'Kirk & Lil Lins' },
          { dia: '14/09/2025', horario: '15h', descricao: 'AK-47' },
          { dia: '14/09/2025', horario: '15h30', descricao: 'Dory de Oliveira' },
          { dia: '14/09/2025', horario: '16h', descricao: 'Dona Kelly' },
          { dia: '14/09/2025', horario: '16h30', descricao: 'Tuca Lélis' },
          { dia: '14/09/2025', horario: '17h', descricao: 'X da Questão' },
          { dia: '14/09/2025', horario: '18h', descricao: 'Cris CNJ' },
          { dia: '14/09/2025', horario: '19h', descricao: 'GOG' },
          { dia: '14/09/2025', horario: '20h', descricao: 'Renan Inquérito' }
        ]
      },
      {
        slug: 'bauru',
        nome: 'Bauru',
        imagem: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/bauru/capa.png'),
        alt: 'Circuito Paulista de Hip Hop em Bauru na segunda edição',
        resumo: 'Cinco dias com Hip Hop Kids, lançamento de documentário, batalhas, exposição e shows de Xis, Realidade Cruel e Afro-X.',
        descricao: [
          'A Semana Hip Hop Origens, 2ª edição, aconteceu em Bauru entre 15 e 19 de outubro de 2025, com cinco dias de programação que uniu formação, memória e celebração. O Hip Hop Kids passou por espaços como Wise Madness, Casa do Garoto e Instituto São Cristovão, enquanto a Troca de Folinha, a Batalha de TAG e a exposição "Pressão e Traço" com Godie marcaram as noites de abertura.',
          'A programação incluiu ainda o Rap Hour, o lançamento do documentário "Semana do Hip Hop: De lá pra cá, 15 Anos de história", o Encontro de DJs no Voodoo Lounge Pub, o Best Trick no Flash Ramp Park e a Batalha Regional de Rima.',
          'O encerramento reuniu Perifeirinha, cypher de Breaking e Graffiti ao lado de uma sequência de shows com DJ Ding, Rapper Scooby, Marie Maresia & Amaranta, Realidade Cruel, Afro-X, Maykvelli, Jovem MK e Xis.'
        ],
        galeria: [
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/bauru/galeria_01.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/bauru/galeria_02.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/bauru/galeria_03.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/bauru/galeria_04.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/bauru/galeria_05.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/bauru/galeria_06.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Bauru'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/bauru/capa.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Bauru'
          }
        ],
        programacao: [
          { dia: '15/10/2025', horario: '09h', descricao: 'Hip Hop Kids - Wise Madness' },
          { dia: '15/10/2025', horario: '19h', descricao: 'Troca de Folinha & Batalha de TAG' },
          { dia: '15/10/2025', horario: '19h', descricao: 'Exposição "Pressão e Traço" com Godie' },
          { dia: '16/10/2025', horario: '09h', descricao: 'Hip Hop Kids - Casa do Garoto' },
          { dia: '16/10/2025', horario: '14h', descricao: 'Hip Hop Kids - Instituto São Cristovão' },
          { dia: '16/10/2025', horario: '19h', descricao: 'Rap Hour' },
          { dia: '16/10/2025', horario: '19h', descricao: 'Lançamento documentário Semana do Hip Hop: De lá pra cá, 15 Anos de história' },
          { dia: '17/10/2025', horario: '09h', descricao: 'Hip Hop Kids - Wise Madness' },
          { dia: '17/10/2025', horario: '14h', descricao: 'Hip Hop Kids - Casa do Garoto' },
          { dia: '17/10/2025', horario: '20h', descricao: 'Encontro de DJs - Voodoo Lounge Pub' },
          { dia: '18/10/2025', horario: '15h', descricao: 'Best Trick - Flash Ramp Park' },
          { dia: '18/10/2025', horario: '19h', descricao: 'Batalha Regional de Rima' },
          { dia: '19/10/2025', horario: '14h', descricao: 'Perifeirinha / cypher de Breaking / Graffiti' },
          { dia: '19/10/2025', horario: '14h', descricao: 'DJ Ding' },
          { dia: '19/10/2025', horario: '15h', descricao: 'Rapper Scooby' },
          { dia: '19/10/2025', horario: '15h30', descricao: 'Marie Maresia & Amaranta' },
          { dia: '19/10/2025', horario: '16h20', descricao: 'Realidade Cruel' },
          { dia: '19/10/2025', horario: '17h30', descricao: 'Afro-X' },
          { dia: '19/10/2025', horario: '18h40', descricao: 'Maykvelli' },
          { dia: '19/10/2025', horario: '19h30', descricao: 'Jovem MK' },
          { dia: '19/10/2025', horario: '20h30', descricao: 'Xis' }
        ]
      },
      {
        slug: 'salto',
        nome: 'Salto',
        imagem: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/capa.png'),
        alt: 'Circuito Paulista de Hip Hop em Salto',
        resumo: 'Encontro de Cultura Independente, Hip Hop Kids, Batalha dos Reais, encontro de graffiti e shows com Afro-X e Crônica Mendes.',
        descricao: [
          'A etapa de Salto aconteceu entre 27 e 30 de novembro de 2025, inaugurando a presença da cidade no circuito com o 1º Encontro de Cultura Independente de Salto. A programação seguiu com o Hip Hop Kids, o Baile da Bran Bran, o Encontro dos DJs e a Batalha dos Reais, ocupando diferentes espaços da cidade ao longo de quatro dias.',
          'O encerramento no domingo começou com o Encontro de Graffiti pela manhã e seguiu com shows de ADJ MC, Neg DDR, Colombiana, Afro-X e Crônica Mendes, consolidando Salto como novo território do circuito.'
        ],
        galeria: [
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_01.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_02.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_03.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_04.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_05.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_06.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_07.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_08.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_09.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_10.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_11.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_12.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_13.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_14.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_15.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_16.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/galeria_17.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Salto'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/salto/capa.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Salto'
          }
        ],
        programacao: [
          { dia: '27/11/2025', horario: '18h', descricao: '1º Encontro de Cultura Independente de Salto' },
          { dia: '28/11/2025', horario: '15h', descricao: 'Hip Hop Kids' },
          { dia: '28/11/2025', horario: '18h', descricao: 'Baile da Bran Bran' },
          { dia: '29/11/2025', horario: '16h', descricao: 'Encontro dos DJs' },
          { dia: '29/11/2025', horario: '19h', descricao: 'Batalha dos Reais' },
          { dia: '30/11/2025', horario: '09h', descricao: 'Encontro de Graffiti' },
          { dia: '30/11/2025', horario: '14h', descricao: 'ADJ MC' },
          { dia: '30/11/2025', horario: '15h', descricao: 'Neg DDR' },
          { dia: '30/11/2025', horario: '16h', descricao: 'Colombiana' },
          { dia: '30/11/2025', horario: '17h', descricao: 'Afro-X' },
          { dia: '30/11/2025', horario: '18h', descricao: 'Crônica Mendes' }
        ]
      },
      {
        slug: 'marilia',
        nome: 'Marília',
        imagem: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/capa.png'),
        alt: 'Circuito Paulista de Hip Hop em Marília',
        resumo: 'Seis dias com oficinas de pipas, breaking, DJ e produção cultural, batalha de rima e shows com Realidade Cruel, Crônica Mendes e Afro X.',
        descricao: [
          'A etapa de Marília aconteceu entre 13 e 18 de janeiro de 2026, com seis dias de programação focada em formação e vivência artística. As oficinas de pipas, breaking, DJ e produção cultural ocuparam os primeiros dias, oferecendo experiências práticas para o público local e abrindo caminhos de aprendizado em diferentes linguagens do hip hop.',
          'O Encontro dos DJs e a Batalha de Rima aqueceram os dias seguintes, e o encerramento trouxe shows de Pry da Rima, Mako, Carvalho 1986, Henrique Rick, Realidade Cruel, Crônica Mendes e Afro X, fechando a etapa com força e diversidade de vozes do rap paulista.'
        ],
        galeria: [
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/galeria_01.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Marília'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/galeria_02.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Marília'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/galeria_03.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Marília'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/galeria_04.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Marília'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/galeria_05.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Marília'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/galeria_06.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Marília'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/galeria_07.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Marília'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/galeria_08.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Marília'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/galeria_09.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Marília'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/marilia/capa.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Marília'
          }
        ],
        programacao: [
          { dia: '13/01/2026', horario: '14h', descricao: 'Oficina de Pipas' },
          { dia: '14/01/2026', horario: '15h', descricao: 'Oficina de Breaking' },
          { dia: '14/01/2026', horario: '18h', descricao: 'Oficina de DJ' },
          { dia: '15/01/2026', horario: '18h', descricao: 'Oficina de Produção Cultural' },
          { dia: '16/01/2026', horario: '19h', descricao: 'Encontro dos DJs' },
          { dia: '17/01/2026', horario: '16h', descricao: 'Batalha de Rima' },
          { dia: '18/01/2026', horario: '15h', descricao: 'Pry da Rima' },
          { dia: '18/01/2026', horario: '15h30', descricao: 'Mako' },
          { dia: '18/01/2026', horario: '16h', descricao: 'Carvalho 1986' },
          { dia: '18/01/2026', horario: '16h30', descricao: 'Henrique Rick' },
          { dia: '18/01/2026', horario: '17h', descricao: 'Realidade Cruel' },
          { dia: '18/01/2026', horario: '18h', descricao: 'Crônica Mendes' },
          { dia: '18/01/2026', horario: '19h', descricao: 'Afro X' }
        ]
      },
      {
        slug: 'araraquara',
        nome: 'Araraquara',
        imagem: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/araraquara/capa.png'),
        alt: 'Circuito Paulista de Hip Hop em Araraquara',
        resumo: 'Hip Hop Kids, roda de conversa Mulheres no Hip Hop, cypher de breaking, live painting e shows com Thaide, Afro-X e Crônica Mendes.',
        descricao: [
          'A etapa de Araraquara aconteceu entre 12 e 15 de março de 2026 e trouxe uma programação que cruzou formação, debate e celebração. O Hip Hop Kids ocupou os dois primeiros dias com atividades nas escolas, e o Encontro dos DJs abriu a programação noturna.',
          'O terceiro dia concentrou ações simultâneas: a Roda de Conversa Mulheres no Hip Hop, o Live Painting de Graffiti, o Cypher de Breaking e a Batalha de MCs com Pocket Show, evidenciando a diversidade de linguagens do movimento.',
          'O encerramento reuniu shows de Amon Poeta, Maps, Bela Triz, Manu, Crônica Mendes, Afro-X e Thaide, um dos nomes mais importantes da história do rap brasileiro, marcando o fechamento da 2ª Edição do Circuito.'
        ],
        galeria: [
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/araraquara/galeria_01.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Araraquara'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/araraquara/galeria_02.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Araraquara'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/araraquara/galeria_03.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Araraquara'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/araraquara/galeria_04.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Araraquara'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/araraquara/galeria_05.png'),
            alt: 'Oficina de graffiti durante o Circuito Paulista de Hip Hop em Araraquara'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/araraquara/galeria_06.png'),
            alt: 'Batalha de rima durante o Circuito Paulista de Hip Hop em Araraquara'
          },
          {
            src: resolvePublicAsset('/images/circuitopaulistahiphop/2aedicao/araraquara/capa.png'),
            alt: 'Apresentação de rap durante o Circuito Paulista de Hip Hop em Araraquara'
          }
        ],
        programacao: [
          { dia: '12/03/2026', horario: '09h', descricao: 'Hip Hop Kids' },
          { dia: '13/03/2026', horario: '09h', descricao: 'Hip Hop Kids' },
          { dia: '13/03/2026', horario: '19h', descricao: 'Encontro dos DJs' },
          { dia: '14/03/2026', horario: '15h', descricao: 'Roda de Conversa Mulheres no Hip Hop' },
          { dia: '14/03/2026', horario: '15h', descricao: 'Live Paiting Graffiti' },
          { dia: '14/03/2026', horario: '15h', descricao: 'Cypher de Breaking' },
          { dia: '14/03/2026', horario: '17h', descricao: 'Batalha de MCs e Pocket Show' },
          { dia: '15/03/2026', horario: '15h', descricao: 'Amon Poeta' },
          { dia: '15/03/2026', horario: '15h30', descricao: 'Maps' },
          { dia: '15/03/2026', horario: '16h', descricao: 'Bela Triz' },
          { dia: '15/03/2026', horario: '16h30', descricao: 'Manu' },
          { dia: '15/03/2026', horario: '17h', descricao: 'Crônica Mendes' },
          { dia: '15/03/2026', horario: '18h', descricao: 'Afro-X' },
          { dia: '15/03/2026', horario: '19h', descricao: 'Thaide' }
        ]
      }
    ]
  }
];

export default circuitoEdicoes;